
export const GET_REPORT_PARAMS_END = 'GET_REPORT_PARAMS_END';
export const GET_REPORT_PARAM_VALUE_END = "GET_REPORT_PARAM_VALUE_END";

export const HANDLE_PARAM_CHANGE="HANDLE_PARAM_CHANGE"
//export const HANDLE_DROPDOWN_CHANGE = "HANDLE_DROPDOWN_CHANGE"

export const GET_REPORTS_END='GET_REPORTS_END'

export const HANDLE_RADIO_BTN_CHANGE='HANDLE_RADIO_BTN_CHANGE'
export const HANDLE_CHECK_BOX_CHANGE='HANDLE_CHECK_BOX_CHANGE'

export const GET_REPORT_URL_END='GET_REPORT_URL_END'

export const CLOSE_REPORT='CLOSE_REPORT'

export const RESET_REPORT = 'RESET_REPORT'
export const UPDATE_PARAM_ID="UPDATE_PARAM_ID"
export const UPDATE_MODAL_DISPLAY_STATE_REPORT_ENGINE="UPDATE_MODAL_DISPLAY_STATE_REPORT_ENGINE"